@if (!isIgnored) {
  <button
    data-dd-action-name="cell-renderers.add-asset-button"
    authorizeEnable
    [disabled]="updating || !hasCreateAssetsPermission"
    [authorizeFeature]="isPremiumIntegrationFeature(integrationType)"
    type="button"
    class="btn btn-outline btn-sm me-2"
    (click)="addAsset()"
  >
    Add Asset
  </button>
  <button
    data-dd-action-name="cell-renderers.add-cost-button"
    authorizeEnable
    [disabled]="updating || !hasCreateAssetsPermission"
    [authorizeFeature]="isPremiumIntegrationFeature(integrationType)"
    type="button"
    class="btn btn-outline btn-sm me-2"
    (click)="addCost()"
  >
    Add Cost
  </button>
  <button
    data-dd-action-name="cell-renderers.ignore-button"
    authorizeEnable
    [disabled]="updating || !hasCreateAssetsPermission"
    [authorizeFeature]="isPremiumIntegrationFeature(integrationType)"
    type="button"
    class="btn btn-outline btn-sm"
    (click)="onIgnore()"
  >
    Ignore
  </button>
}
